export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10215.025ff7d8.jpg";